import { AlertOutlined, CheckOutlined } from '@ant-design/icons';
import { JsonValue } from '@prisma/client/runtime/library';
import { Tag, TagProps } from 'antd';

import { RuleMessage } from '@app/domain-interfaces';
import { Theme } from '@app/web-components';

import { EligibilityPopover } from '../../subscriptions/modals';

export type EligibilityRendererProps = {
  eligibility: JsonValue;
  isEligible: boolean | null | undefined;
};

export const useEligibilityTag = () => {
  const { token } = Theme.useToken();

  const getProps = (eligible: boolean | undefined, props?: TagProps): TagProps => ({
    ...props,
    children: eligible ? 'Yes' : 'No',
    color: eligible ? token['bright-success'] : token['bright-error'],
    hidden: eligible === undefined,
    icon: eligible ? <CheckOutlined title="Yes" /> : <AlertOutlined title="No" />,
    style: { ...props?.style, margin: 0 },
  });

  return { getProps };
};

export const EligibilityRenderer = ({ eligibility, isEligible }: EligibilityRendererProps) => {
  const { getProps } = useEligibilityTag();

  if (!eligibility || isEligible === null || isEligible === undefined) return undefined;

  const messages = eligibility as RuleMessage[];

  return (
    <EligibilityPopover messages={messages}>
      <Tag {...getProps(isEligible)} />
    </EligibilityPopover>
  );
};
